import { ApiPaths } from "../../../api/ApiPaths";
import { ServiceProviderId } from "../../../../domain/service_provider/ServiceProviderId";
import { ServiceProviderName } from "../../../../domain/service_provider/ServiceProviderName";
import { ServiceProviderSpId } from "../../../../domain/service_provider/ServiceProviderSpId";
import { ServiceProviderSharedPassword } from "../../../../domain/service_provider/ServiceProviderSharedPassword";
import { ApiRequest } from "../../../api/ApiRequest";

export type GetServiceProviderListResponseType = {
    serviceProviders: [{
        id: string,
        name: string
    }],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}
export async function getServiceProviderList(): Promise<GetServiceProviderListResponseType > {
    return await ApiRequest.get(ApiPaths.admin.serviceProviderList, {}, () => {}, () => {});
}


export type GetServiceProviderInformationSuccessResponseType = {
    id: string,
    name: string,
    spId: string,
    sharedPassword: string,
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}
export async function getServiceProviderInformation(serviceProviderId: ServiceProviderId,): Promise<GetServiceProviderInformationSuccessResponseType> {
    return await ApiRequest.get(ApiPaths.admin.serviceProviderInformation.replace(/\{serviceProviderId\}/g, serviceProviderId.value),
        {},
        () => {},
        () => {}
    );
}

export async function registerServiceProviderInformation(
    serviceProviderName: ServiceProviderName,
    serviceProviderSpId: ServiceProviderSpId,
    serviceProviderSharedPassword: ServiceProviderSharedPassword
) {
    const body = {
        name: serviceProviderName.value,
        spId: serviceProviderSpId.value,
        sharedPassword: serviceProviderSharedPassword.value
    };

    return await ApiRequest.post(
        ApiPaths.admin.serviceProviderRegister,
        {},
        body,
        () => {},
        () => {}
    );
}

export async function updateServiceProviderInformation(
    serviceProviderId: ServiceProviderId,
    serviceProviderName: ServiceProviderName,
    serviceProviderSpId: ServiceProviderSpId,
    serviceProviderSharedPassword: ServiceProviderSharedPassword
) {
    const body = {
        name: serviceProviderName.value,
        spId: serviceProviderSpId.value,
        sharedPassword: serviceProviderSharedPassword.value
    };
    return await ApiRequest.post(ApiPaths.admin.serviceProviderInformation.replace(/\{serviceProviderId\}/g, serviceProviderId.value),
        {},
        body,
        () => {},
        () => {}
    );
}
